import React from "react";

const Block4 = () => {
  return (
    <>
      <div className="flex flex-col md:flex-row px-2 md:px-0 pt-5 md:py-6">
        {/* Image */}
        <div className="w-full md:w-4/12">
          <img src="https://demo.tagdiv.com/newspaper_pro/wp-content/uploads/2019/08/97-696x464.jpg" />
        </div>
        
        
        {/* Details */}
        <div className="w-full md:w-8/12 text-xl px-0 md:px-5 py-6 md:py-0 flex flex-col justify-between">
          <div className="font-medium text-black cursor-pointer">
            KTM Marchetti Signs with Larranaga and Zanotti for Next Season
            {/* Author + Date */}
            <div className="flex flex-row">
              {/* Author */}
              <div className="text-xs-s font-bold">God Of Thunder</div>
              {/* Date */}
              <div className="text-xs-s font-semibold text-gray-400 ml-4">
                August 7, 2021
              </div>
            </div>
          </div>

          {/* Description */}
          <div className="text-gray-600 text-xs">
            We woke reasonably late following the feast and free flowing wine
            the night before. After gathering ourselves and our packs, we headed
            down to our homestay family’s small dining...
          </div>
        </div>
      </div>
    </>
  );
};

export default Block4;
